import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import HomePage from '../Componenets/HomePage'
import TagNewsview from '../Componenets/TagNewsview'
import BreakingNews from '../Componenets/BreakingNews'
import VideoNewsview from '../Componenets/VideoNewsview'
import BookmarkSection from '../Componenets/BookmarkSection'
import NewsView from '../Componenets/NewsView'
import Categories from '../Componenets/Categories'
import LiveNews from '../Componenets/LiveNews'
import Notification from '../Componenets/Notification'
import NewsNotification from '../Componenets/NewsNotification'
import ViewAll from "../Componenets/ViewAll"
import CategoryNews from '../Componenets/CategoryNews'
import BreakingNewsView from '../Componenets/BreakingNewsView'
import UserBasedCategories from '../Componenets/UserBasedCategories'
import MorePages from '../Componenets/MorePages'
import ProfileUpdate from '../Componenets/ProfileUpdate'
import FilterPage from '../Componenets/FilterPage'
import FilterPageidshow from '../Componenets/idDetailsshow'
import GalleryImage from '../Componenets/allgallery'
import DonationForm from '../Componenets/demoData'
import Donateimage from '../Componenets/Donateimage'
import Donateimage1 from '../Componenets/Donateimage1'
import Donateimage2 from '../Componenets/Donateimage2'
import DonateCampaignDetail from '../Componenets/DonateCampaignDetail'
import VerifyCard from '../Componenets/VerifyCard'

const Router = () => {
  return (
    <Routes>
      <Route exact="true" path="/" element={<HomePage />}></Route>
        <Route exact="true" path="/categories-view/:catid" element={<CategoryNews/>}></Route>
        <Route exact="true" path="/tag/:tagid" element={<TagNewsview />}></Route>
        <Route exact="true" path="/breaking-news/:bnewsid" element={<BreakingNews />}></Route>
        <Route exact="true" path="/breaking-news-view" element={<BreakingNewsView />}></Route>
        <Route exact="true" path="/video-news-view/:vid" element={<VideoNewsview />}></Route>
        <Route exact="true" path="/bookmark" element={<BookmarkSection />}></Route>
        <Route exact="true" path="/news/:newsid/:catid" element={<NewsView />}></Route>
        <Route exact="true" path="/view-all/:id" element={<ViewAll />}></Route>
        <Route exact="true" path="/categories" element={<Categories />}></Route>
        <Route exact="true" path="/live-news" element={<LiveNews />}></Route>
        <Route exact="true" path="/notification" element={<Notification />}></Route>
        <Route exact="true" path="/news-notification" element={<NewsNotification />}></Route>
        <Route exact="true" path="/persnol-notification" element={<Notification />}></Route>
        <Route exact="true" path="/user-based-categories" element={<UserBasedCategories />}></Route>
        <Route exact="true" path="/more-pages" element={<MorePages />}></Route>
        <Route exact="true" path="/create-news" element={<Navigate to="/" replace />}></Route>
        <Route exact="true" path="/manage-news" element={<Navigate to="/" replace />}></Route>
        <Route exact="true" path="/edit-news" element={<Navigate to="/" replace />}></Route>
        <Route exact="true" path="/profile-update" element={<ProfileUpdate />}></Route>
        <Route exact="true" path="/donate-page" element={<Navigate to="/donationform" replace />}></Route>
        <Route exact="true" path="/donate-page1" element={<Navigate to="/donationform" replace />}></Route>
        <Route exact="true" path="/donate-page2" element={<Navigate to="/donationform" replace />}></Route>
        <Route exact="true" path="/donate-page3" element={<Navigate to="/donationform" replace />}></Route>
        <Route exact="true" path="/donate-page4" element={<Navigate to="/donationform" replace />}></Route>
        <Route exact="true" path="/filter-page" element={<FilterPage />}></Route>
        <Route exact="true" path="/iddetails-page" element={<FilterPageidshow />}></Route>
        <Route exact="true" path="/gallery-image" element={<GalleryImage />}></Route>
        <Route exact="true" path="/donationform" element={<DonationForm />}></Route>
        <Route exact="true" path="/donationimage" element={<Donateimage />}></Route>
        <Route exact="true" path="/donationimage1" element={<Donateimage1 />}></Route>
        <Route exact="true" path="/donationimage2" element={<Donateimage2 />}></Route>
        <Route exact="true" path="/donate-campaign/:id" element={<DonateCampaignDetail />}></Route>
        <Route exact="true" path="/verify-card/:token" element={<VerifyCard />}></Route>
    </Routes>

  )
}

export default Router